import React, { useState } from 'react';

function OrderList({ orders, onBack, onReview }) {
  const [reviewingOrder, setReviewingOrder] = useState(null);
  const [ratings, setRatings] = useState({});
  const [comments, setComments] = useState({});
  const [overallRating, setOverallRating] = useState(5);
  const [overallComment, setOverallComment] = useState('');

  const openReviewModal = (order) => {
    // 初始化每个菜品的评分和评价
    const initialRatings = {};
    const initialComments = {};
    order.items.forEach(item => {
      initialRatings[item.product_id] = 5;
      initialComments[item.product_id] = '';
    });
    setRatings(initialRatings);
    setComments(initialComments);
    setOverallRating(5);
    setOverallComment('');
    setReviewingOrder(order);
  };

  const submitProductReview = async () => {
    const productReviews = Object.keys(ratings).map(productId => ({
      product_id: parseInt(productId),
      rating: ratings[productId],
      comment: comments[productId] || ''
    }));
    
    await onReview(
      reviewingOrder.id, 
      overallRating, 
      overallComment || '', 
      productReviews
    );
    setReviewingOrder(null);
  };

  if (orders.length === 0) {
    return (
      <div>
        <button className="back-btn" onClick={onBack}>← 返回首页</button>
        <p>暂无订单</p>
      </div>
    );
  }

  // 评价弹窗
  if (reviewingOrder) {
    return (
      <div style={{ padding: '16px' }}>
        <button className="back-btn" onClick={() => setReviewingOrder(null)}>← 返回订单列表</button>
        <h2 style={{ fontSize: '18px', marginBottom: '16px' }}>📝 评价订单 #{reviewingOrder.order_number}</h2>
        
        {/* 整体评价 */}
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '16px',
          border: '1px solid #e0e0e0'
        }}>
          <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '12px' }}>🏪 整体评价</div>
          <div style={{ marginBottom: '12px' }}>
            <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>整体评分：</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {[1, 2, 3, 4, 5].map(star => (
                <button
                  key={star}
                  onClick={() => setOverallRating(star)}
                  style={{
                    background: overallRating >= star ? '#ff9800' : '#eee',
                    color: overallRating >= star ? 'white' : '#999',
                    border: 'none',
                    width: '50px',
                    padding: '8px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}
                >
                  {star}⭐
                </button>
              ))}
            </div>
          </div>
          <div>
            <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>整体评价：</div>
            <textarea
              value={overallComment}
              onChange={(e) => setOverallComment(e.target.value)}
              placeholder="说说这次用餐体验..."
              style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
              rows="2"
            />
          </div>
        </div>
        
        {/* 菜品评价 */}
        <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '12px' }}>🍽️ 菜品评价</div>
        {reviewingOrder.items.map((item, idx) => (
          <div key={idx} style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '16px',
            border: '1px solid #e0e0e0'
          }}>
            <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '12px' }}>{item.product_name}</div>
            <div style={{ marginBottom: '12px' }}>
              <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>评分：</div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {[1, 2, 3, 4, 5].map(star => (
                  <button
                    key={star}
                    onClick={() => setRatings({...ratings, [item.product_id]: star})}
                    style={{
                      background: ratings[item.product_id] >= star ? '#ff9800' : '#eee',
                      color: ratings[item.product_id] >= star ? 'white' : '#999',
                      border: 'none',
                      width: '50px',
                      padding: '8px',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                  >
                    {star}⭐
                  </button>
                ))}
              </div>
            </div>
            <div>
              <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>评价：</div>
              <textarea
                value={comments[item.product_id] || ''}
                onChange={(e) => setComments({...comments, [item.product_id]: e.target.value})}
                placeholder="说说这道菜怎么样..."
                style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px' }}
                rows="2"
              />
            </div>
          </div>
        ))}
        
        <button
          onClick={submitProductReview}
          style={{
            background: '#ff6b6b',
            color: 'white',
            border: 'none',
            padding: '12px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 'bold',
            width: '100%',
            cursor: 'pointer',
            marginTop: '16px'
          }}
        >
          提交评价
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: '16px' }}>
      <button className="back-btn" onClick={onBack}>← 返回首页</button>
      <h2 style={{ fontSize: '18px', marginBottom: '16px' }}>我的订单</h2>
      {orders.map(order => (
        <div key={order.id} style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '16px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e0e0e0'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '12px',
            paddingBottom: '12px',
            borderBottom: '1px solid #f0f0f0'
          }}>
            <div>
              <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#666' }}>订单号</div>
              <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{order.order_number}</div>
              <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>🕐 {new Date(order.created_at).toLocaleString()}</div>
            </div>
            <div style={{
              background: order.status === 'pending' ? '#ff9800' : order.status === 'confirmed' ? '#4caf50' : order.status === 'preparing' ? '#2196f3' : order.status === 'delivered' ? '#9e9e9e' : '#f44336',
              color: 'white',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: 'bold'
            }}>
              {order.status === 'pending' ? '待确认' : order.status === 'confirmed' ? '已确认' : order.status === 'preparing' ? '备餐中' : order.status === 'delivered' ? '已送达' : '已取消'}
            </div>
          </div>

          <div style={{ marginBottom: '12px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '14px', color: '#666' }}>🏪 商家信息</div>
            <div style={{ background: '#f9f9f9', padding: '10px', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '14px' }}>{order.merchant_name || `商家 ${order.merchant_id}`}</span>
                {order.merchant_username && (
                  <a href={`https://t.me/${order.merchant_username}`} target="_blank" rel="noopener noreferrer" style={{ background: '#2196f3', color: 'white', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', textDecoration: 'none' }}>
                    💬 联系商家
                  </a>
                )}
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '12px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '14px', color: '#666' }}>🍽️ 商品明细</div>
            {order.items && order.items.length > 0 ? (
              <div style={{ background: '#f9f9f9', padding: '10px', borderRadius: '8px' }}>
                {order.items.map((item, idx) => (
                  <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: '14px', borderBottom: idx < order.items.length - 1 ? '1px solid #eee' : 'none' }}>
                    <span>{item.product_name} x {item.quantity}</span>
                    <span>RM {(item.price * item.quantity).toFixed(2)}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ color: '#999', fontSize: '14px', padding: '8px', background: '#f9f9f9', borderRadius: '8px' }}>暂无商品明细</div>
            )}
          </div>

          <div style={{ marginBottom: '12px', fontSize: '14px', color: '#666' }}>
            <div style={{ marginBottom: '6px' }}>
              💰 总金额: <span style={{ fontWeight: 'bold', color: '#ff6b6b' }}>RM {order.total_amount}</span>
              {order.delivery_fee > 0 && <span style={{ marginLeft: '10px' }}>🚚 配送费: RM {order.delivery_fee}</span>}
            </div>
            <div style={{ marginBottom: '6px' }}>
              🏠 地址: {order.delivery_address || order.address_text || '未填写'}
              {order.address_note && <span style={{ color: '#999' }}> ({order.address_note})</span>}
            </div>
            <div style={{ marginBottom: '6px' }}>
              💳 支付方式: {order.payment_method || '现金'}
            </div>
            {order.note && (
              <div style={{ marginBottom: '6px' }}>
                📝 备注: {order.note}
              </div>
            )}
          </div>

          <div style={{ display: 'flex', gap: '10px', marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #f0f0f0' }}>
            {order.is_reviewed === 0 && order.status === 'delivered' && (
              <button onClick={() => openReviewModal(order)} style={{ background: '#ff6b6b', color: 'white', border: 'none', padding: '8px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' }}>📝 评价订单</button>
            )}
            {order.is_reviewed === 1 && <span style={{ color: '#4caf50', fontSize: '14px' }}>✅ 已评价</span>}
            {order.status !== 'delivered' && order.status !== 'cancelled' && <span style={{ color: '#999', fontSize: '14px' }}>⏳ 订单完成后可评价</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default OrderList;
